import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';

const getFilteredProductCategoryList = (productCategoryList) => {
  return productCategoryList
    .filter((x) => !x.productCategoryId)
    .map((x) => {
      return { id: x.id, name: x.name };
    });
};

const getFilteredProductSubcategoryList = (productCategoryList, fields) => {
  return productCategoryList
    .filter((x) => fields && x.productCategoryId === fields.productCategoryId)
    .map((x) => {
      return { id: x.id, name: x.name };
    })
    .concat({ id: '', name: '-' });
};

const ProductType = ({ fields, productCategoryList }) => [
  {
    name: 'productCategoryId',
    validation: yup.string().nullable(true),
    type: FormFieldType.SELECT,
    value: fields && fields.productCategoryId ? fields.productCategoryId : '',
    options: getFilteredProductCategoryList(productCategoryList),
    fullWidth: true
  },
  {
    name: 'productSubcategoryId',
    validation: yup.string().nullable(true),
    type: FormFieldType.SELECT,
    value:
      fields && fields.productSubcategoryId ? fields.productSubcategoryId : '',
    options: getFilteredProductSubcategoryList(productCategoryList, fields),
    fullWidth: true
  },
  {
    name: 'barCode',
    validation: yup.string(),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.barCode ? fields.barCode : '',
    fullWidth: true
  },
  {
    name: 'name',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.name ? fields.name : '',
    fullWidth: true
  },
  {
    name: 'manufacturer',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.manufacturer ? fields.manufacturer : ''
  },
  {
    name: 'model',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.model ? fields.model : ''
  },
  {
    name: 'code',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.code ? fields.code : ''
  },
  {
    name: 'costPrice',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.costPrice ? fields.costPrice : '0'
  },
  {
    name: 'salePrice',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.salePrice ? fields.salePrice : '0'
  },
  {
    name: 'description',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_AREA,
    value: fields && fields.description ? fields.description : '',
    fullWidth: true
  }
];

export default ProductType;
